import { gql } from '@apollo/client';

export const GET_LATEST_PORTAL_DECLARATION = gql`
  query getLatestPortalDeclaration {
    declaration: getLatestPortalDeclaration {
      id
      createdAt
      updatedAt

      published
      text
      title
      version

      createdBy {
        id
        firstName
        lastName
      }
      modifiedBy {
        id
        firstName
        lastName
      }
      portal {
        id
        name
      }
    }
  }
`;
